import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';

import SideNav from '../SideNav';
import ProfileIcon from './ProfileIcon';
import Notification from './Notification';
import AdminHeaderLinks from './adminHeaderLinks';
import ClientHeaderLinks from './clientHeaderLinks';
import TrainerHeaderLinks from './trainerHeaderLinks';

import OmniLogo from '../../assets/images/png/OmniLogoNew.png';

import CustomButton from '../CustomButton';
import AddLocation from '../../pages/Locations/AddLocation';
import StripeConnectButton from '../StripeConnectButton';

import useGetUnreadChatCount from '../../customHooks/useGetUnreadChatCount';

import CONSTANTS from '../../utils/constants/CONSTANTS';
import { setAddLocation } from '../../redux/location/LocationAction';
import { getAdminStripeStatusAsync, stripeConnectAsync } from '../../redux/user/UserAction';

import './index.scss';

const Header = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const isStripeRefreshed = searchParams.get('stripe-refresh');

  const userType = useSelector((state) => state.user.userType);
  const isSuperAdmin = useSelector((state) => state.user.currentUser.is_superuser);
  const addNewLocation = useSelector((state) => state.locations.addNewLocation);

  const unreadChatCount = useGetUnreadChatCount();

  const openAddLocationModal = () => {
    dispatch(setAddLocation(true));
  };

  useEffect(() => {
    if (!isSuperAdmin && userType === CONSTANTS.ADMIN) {
      dispatch(getAdminStripeStatusAsync());
    }
  }, [userType, isSuperAdmin]);

  useEffect(() => {
    if (isStripeRefreshed) {
      dispatch(stripeConnectAsync());
    }
  }, [isStripeRefreshed]);

  return (
    <div className="header">
      {userType === CONSTANTS.CLIENT ? <SideNav /> : null}
      <Link to={`${CONSTANTS.URL_LIST.DASHBOARD}`}>
        <img src={OmniLogo} className="logo-container" alt="website logo" />
      </Link>

      <div className="options">
        {userType === CONSTANTS.CLIENT && <ClientHeaderLinks />}
        {userType === CONSTANTS.ADMIN && <AdminHeaderLinks unreadChatCount={unreadChatCount} />}
        {userType === CONSTANTS.TRAINER && <TrainerHeaderLinks unreadChatCount={unreadChatCount} />}
      </div>

      <div className="login-status">
        {isSuperAdmin && (
          <div className="button">
            <CustomButton value="submit" type={CONSTANTS.SAVE_TYPE} handleClick={openAddLocationModal}>
              Add New Location
            </CustomButton>
          </div>
        )}
        {!isSuperAdmin && userType === CONSTANTS.ADMIN && (
          <div className="button">
            <StripeConnectButton />
          </div>
        )}
        <ProfileIcon />
        <Notification />
      </div>
      {isSuperAdmin && addNewLocation && <AddLocation />}
    </div>
  );
};

export default Header;
